module.exports = __webpack_public_path__ + "static/media/power655.888d564b.png";